import { ElementType, Template } from "@/types/builder";

const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

export const VideoPausePopup: Template = {
  id: generateId(),
  name: "Video Pause Popup",
  industry: "restaurant",
  elements: [{
    id: generateId(),
    type: "container" as ElementType,
    styles: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px 40px",
      textAlign: "center",
      width: "1050px",
      height: "610px",
      borderRadius: "12px",
      border: "6px solid #FBBC04",
      backgroundColor: "#F7F7F7",
    },
    responsiveStyles: {
      tablet: {
        width: "640px",
        height: "480px",
      },
      mobile: {
        width: "320px",
        height: "420px",
      },
    },
    children: [
      {
        id: generateId(),
        type: "heading" as ElementType,
        content: "Wait",
        styles: {
          fontSize: "64px",
          fontWeight: "900",
          lineHeight: "80px",
          color: "#E5102E",
        },
      },
    ],
  }],
};
